module.exports = __webpack_public_path__ + "img/nomal.0511d502.png";